import { Component, Input } from "@angular/core";

@Component({
  selector: 'purchase-order-status',
  templateUrl: './purchase-order-status.component.html'
})
export class PurchaseOrderStatusComponent {
  @Input()
  status!: string
}